import React, { Fragment, useState, useEffect } from "react";
import BlockRouteOnAutoModeModal from "./BlockRouteOnAutoModeModal";
import { useHistory } from "react-router-dom";
import ImagingModeModal from "../Overview/ImagingModeModal";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleStateById } from "../../redux/reducers/ModuleStateReducer";
import { EImagingMode } from "../../Model/EImagingMode";

type Props = {
  show: boolean;
  onHide: () => void;
  redirectOkTo?: string;
  redirectCancelTo?: string;
  name?: string; // to add into radio button id
};

export default function BlockAndChangeToManualModeModal({
  show,
  onHide,
  redirectOkTo,
  redirectCancelTo,
  name = "",
}: Props) {
  const history = useHistory();
  const [showCantEnter, setShowCantEnter] = useState(false);
  const [showChangeImagingMode, setShowChangeImagingMode] = useState(false);
  const [toggleRedirectOk, setToggleRedirectOk] = useState(false);

  const isImagingManualMode = useTypedSelector(
    (state) =>
      getModuleStateById(state)["Suite"].suite?.imagingMode ==
      EImagingMode.Manual
  );

  useEffect(() => {
    setShowCantEnter(show);
  }, [show]);

  //need wait imaging mode to manual then redirect OK
  useEffect(() => {
    if(isImagingManualMode && toggleRedirectOk && redirectOkTo){
      setToggleRedirectOk(false);
      history.push(redirectOkTo);
    }
  }, [isImagingManualMode])

  return (
    <Fragment>
      <BlockRouteOnAutoModeModal
        show={showCantEnter}
        onHide={() => {
          setShowCantEnter(false);
          onHide();
          if (redirectCancelTo) {
            history.push(redirectCancelTo);
          }
        }}
        onClickSwitch={() => {
          setShowCantEnter(false);
          setShowChangeImagingMode(true);
        }}
      />

      <ImagingModeModal
        show={showChangeImagingMode}
        onHide={() => {
          setShowChangeImagingMode(false);
        }}
        onOk={() => {
          setToggleRedirectOk(true);
          setShowCantEnter(false);
          setShowChangeImagingMode(false);
          onHide();
        }}
        onCancel={() => setShowCantEnter(true)}
        name={name}
      />
    </Fragment>
  );
}
